module.exports = __webpack_public_path__ + "static/media/summerCut-03.aed01048.png";